import * as Yup from 'yup';

export const validationSchema = Yup.object({
  title: Yup.string()
    .required('Title is required')
    .min(1, 'Title must be at least 1 character')
    .max(100, 'Title must be at most 100 characters')
    .matches(
      /^[a-zA-Z0-9-_ ]*$/,
      'Only letters, numbers, spaces, hyphens, and underscores are allowed'
    )
    .trim(),
});
